export default __webpack_public_path__ + "static/media/body-arms.ef291f14.png";